/*
 * Copyright Mimic Networks, Inc. 2026.
 */

import { AlertConfigDetailsPage } from '@/pages/NotificationManagement/AlertConfigDetailsPage';

export function AlertConfigDetailsRoute() {
  return <AlertConfigDetailsPage />;
}
